// ----------------------------------------------------------------------------
// Принятие соглашения пользователем
// ----------------------------------------------------------------------------


const accept_agreement = (type = 'regular_user', user = 0) => {
    const domain = window.location.hostname.replace('guides.', '');

    const formData = new URLSearchParams({
        'type': type,
        'user': user
    });

    fetch(`https://${domain}/web/accept-agreement`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest' // Оставляем, так как бэкенд может проверять, что это AJAX
        },
        body: formData
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Сетевая ошибка сервера');
            }
            return response.json();
        })
        .then(data => {
            if (data.error === 0) {
                const modalWindowsAgreement = document.querySelectorAll('.modal-window-wrapper_agreement');

                modalWindowsAgreement.forEach(modalWindow => modalWindow.remove());
            }
        })
        .catch(error => {
            console.error('Ошибка при отправке соглашения:', error);
        });
}

export default accept_agreement;
